import React from 'react'
import FormInput from './index'

interface Props {
  label: string
  name: string
  value: string | number
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder: string
  error: string | undefined
  size?: 'sm' | 'md' | 'lg'
  className?: string
  disabled?: boolean
  type?: 'text' | 'email' | 'password' | 'number'
}

const FormInputRow: React.FC<Props> = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  error,
  size = 'md',
  className = '',
  disabled = false,
  type = 'text',
}) => {
  return (
    <div className={`gap-2.5 flex flex-col ${size} ${className}`}>
      <p className=" leading-7 font-medium text-[#6C757D]">{label}</p>
      <div>
        <FormInput
          value={value}
          onChange={onChange}
          name={name}
          size={size}
          placeholder={placeholder}
          error={error}
          className="custom-input"
          disabled={disabled}
          type={type}
        />
      </div>
    </div>
  )
}

export default FormInputRow
